import { render, staticRenderFns } from "./InitialPaymentSelector.vue?vue&type=template&id=3946cef8&"
import script from "./InitialPaymentSelector.vue?vue&type=script&lang=js&"
export * from "./InitialPaymentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports